<template>
  <b-container fluid>
    <h1 class="mt-4">Preparations</h1>
    <h2>Medical checks</h2>
    <h4 class="text-left mb-4">Examining doctor: Stephanie Kühnl</h4>
    <b-form-radio-group
      class="text-left mb-1"
      id="radio-group"
      name="filters"
      :options="options"
      v-model="filter"
    ></b-form-radio-group>
    <b-form-input v-model="searchTeam" placeholder="Search Team"></b-form-input>
    <b-table
      :fields="fields"
      head-variant="dark"
      :items="filteredItems"
      small
      sort-by="team"
      sort-icon-left
      :tbody-tr-class="rowClass"
    >
      <template v-slot:cell(athlete)="data">
          {{ data.item.first_name }} {{ data.item.last_name }}
      </template>
      <template v-slot:cell(birthday)="data">
        {{ new Date(data.item.birthday).toLocaleDateString() }}
      </template>
      <template v-slot:cell(action)="data">
        <b-button
          block
          size="sm"
          :to="{ name: 'MedicalEvaluationGeneralData', params: { id: data.item.id } }"
          variant="primary"
        >Open</b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script>
export default {
  name: 'MedicalEvaluation.vue',
  data() {
    return {
      fields: [
        { key: 'team', sortable: true },
        { key: 'athlete', sortable: true },
        { key: 'birthday', sortable: true },
        { key: 'medicalClearance', label: 'Status', sortable: true },
        { key: 'action' },
      ],
      filter: 'all',
      options: [
        { text: 'No filter', value: 'all' },
        { text: 'Cleared', value: null },
        { text: 'Rejected', value: false },
        { text: 'Waiting', value: true },
      ],
      searchTeam: '',
    };
  },
  methods: {
    approve(id) {
      this.$store.commit('setValue', {
        id,
        key: 'medicalClearance',
        value: 'cleared',
      });
    },
    reject(id) {
      this.$store.commit('setValue', {
        id,
        key: 'medicalClearance',
        value: 'rejected',
      });
    },
    remove(id) {
      this.$store.commit('setValue', {
        id,
        key: 'medicalClearance',
        value: 'waiting',
      });
    },
    rowClass(item) {
      // TODO Replace by Competition Fit of PreEvalution
      if (item.medicalClearance === true) return 'table-success';
      if (item.medicalClearance === false) return 'table-danger';
      return '';
    },
  },
  computed: {
    filteredItems() {
      let items = this.$store.getters.getAthletes;
      if (this.searchTeam) {
        items = items.filter((i) => i.team.toLowerCase().includes(this.searchTeam.toLowerCase()));
      }
      if (this.filter !== 'all') {
        items = items.filter((i) => i.medicalClearance === this.filter);
      }
      return items;
    },

  },
};
</script>

<style scoped>
  .capitalize {
    text-transform: capitalize;
  }
</style>
